export const USED_LANGUAGES = ["hr"];

export const MAIN_LANGUAGE = "hr";
